/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Коллекция для контактов пользователя
   */
  app.UserContacts = app.Collection.extend({

    model: app.UserContact,

    url: app.entryScriptName + '/api/v3/user-contact',
  });

})();

}.call(window));